export default "__VITE_ASSET__5540fdd2__"